var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoTip = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2c-4.4183 0-8 3.5818-8 8 0 4.4185 3.5817 8 8 8s8-3.5815 8-8c0-4.4182-3.5817-8-8-8m0 4c.5523 0 1 .4478 1 1 0 .5525-.4477 1-1 1s-1-.4475-1-1c0-.5522.4477-1 1-1m1.5 8h-3a.5.5 0 0 1 0-1H9v-3h-.5a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5V13h.5a.5.5 0 0 1 0 1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoTip);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info-tip.7c968797469ce45d20e4d315eced4406.svg";